export const CREATE_PAYMENT_REQUEST = 'CREATE_PAYMENT_REQUEST';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAIL = 'CREATE_PAYMENT_FAIL';
export const GET_RECENT_PAYMENT_REQUEST = 'GET_RECENT_PAYMENT_REQUEST';
export const GET_RECENT_PAYMENT_SUCCESS = 'GET_RECENT_PAYMENT_SUCCESS';
export const GET_RECENT_PAYMENT_FAIL = 'GET_RECENT_PAYMENT_FAIL';

